import React from 'react';
import { X } from 'lucide-react';

const PageModal = ({ children, onClose }) => {
  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      if (onClose) {
        onClose();
      }
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="page-modal-local-overlay" onClick={handleBackgroundClick}>
      <div className="page-modal-local-content">
        <button className="page-modal-local-close" onClick={handleClose}>
          <X size={20} />
        </button>
        <div className="page-modal-local-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageModal; 